





















import 'reflect-metadata'
import { Component, Watch, Mixins } from 'vue-property-decorator'
import { BlocksGettersMixin } from '@/store/modules/blocks/blocks.mixins'
import { getMappingForType } from '@/store/modules/blocks/maps'
import Loader from '@/components/misc/Loader.vue'
import HTTPError from '@/components/misc/HTTPError.vue'
import EVMBlockSummary from '@/components/Block/EVMBlockSummary.vue'

@Component({
    components: {
        Loader,
        HTTPError,
        EVMBlockSummary,
    },
    filters: {
        getType: getMappingForType,
    },
})
export default class EVMBlockPage extends Mixins(BlocksGettersMixin) {
    loading = false
    breadcrumbs: any = [
        {
            text: 'Home',
            disabled: false,
            href: '/',
        },
        {
            text: 'Blocks',
            disabled: false,
            href: '/', // TODO
        },
        {
            text: 'Detail',
            disabled: true,
            href: '',
        },
    ]

    @Watch('blockId')
    onblockIdChanged() {
        this.getData()
    }

    @Watch('assetsLoaded')
    onAssetsLoaded() {
        this.getData()
    }

    created() {
        this.getData()
    }

    get assetsLoaded() {
        return this.$store.state.assetsLoaded
    }

    get blockId(): string {
        return this.$route.params.id
    }

    get block() {
        return this.getEVMBlock()
    }

    getData(): void {
        this.loading = true
        if (this.assetsLoaded) {
            this.$store
                .dispatch('Blocks/getEVMBlock', this.blockId)
                .then(() => {
                    this.loading = false
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    }
}
